export const Wishbone = ({ size = 28, className = "" }) => (
  <img
    src="/cross-logo.png"
    alt="Cross"
    width={size}
    height={size}
    style={{ width: size, height: size }}
    className={`rounded-full object-cover shrink-0 shadow-[0_0_20px_-4px_rgba(124,58,237,0.75)] ${className}`}
    data-testid="brand-mark"
  />
);
